















































import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Actions, Mutations, Endpoints } from '@/ts/store/Constants';
import WaitingList from '@/components/Admin/Lists/WaitingList.vue';
import PreviewDocument from '@/components/Admin/Panels/PreviewDocument.vue';
import PreviewAvailableApartments from '@/components/Admin/Panels/PreviewAvailableApartments.vue';
import ExpirationEmail from '@/components/Admin/Panels/ExpirationEmail.vue';
import ApplicationFlyout from '@/components/Flyouts/ApplicationFlyout.vue';
import { CANCEL_REQUEST_BY } from '@/ts/interfaces/Loading';

import axios from 'axios';

@Component({
    components: {
        WaitingList,
        PreviewAvailableApartments,
        PreviewDocument,
        ExpirationEmail,
        ApplicationFlyout,
    },
    computed: {
        ...mapGetters({
            reviewApplicationVisible: 'WaitingLists/getIfreviewApplicationVisible',
            availableApartmentsVisible: 'WaitingLists/getAvailableApartmentsVisible',
            previewedDocumentLoading: 'WaitingLists/getPreviewedDocumentLoading',
            previewedApplication: 'WaitingLists/getPreviewedApplication',
            expirationEmailVisible: 'WaitingLists/getExpirationEmailVisible',
        }),
    },
})
export default class WaitingLists extends Vue {
    public tabs: any[] = [
        {
            title: 'All applications',
            translations_key: 'all-applications',
            status: true,
            requestOption: 'all',
        },
        {
            title: 'Active applications',
            translations_key: 'active-applications',
            status: false,
            requestOption: 'active',
        },
        {
            title: 'Passive applications',
            translations_key: 'passive-applications',
            status: false,
            requestOption: 'passive',
        },
        {
            title: 'Accepted applications',
            translations_key: 'accepted-applications',
            status: false,
            requestOption: 'accepted',
        },
        {
            title: 'Rejected applications',
            translations_key: 'rejected-applications',
            status: false,
            requestOption: 'rejected',
        },
        {
            title: 'Completed applications',
            translations_key: 'completed-applications',
            status: false,
            requestOption: 'completed',
        },
    ];

    constructor() {
        super();
    }

    get activeType(): string {
        return this.$store.getters['WaitingLists/getRequestTypeOption'];
    }

    public downloadStatusSheet() {
        axios({
            url: Endpoints.Admin.WaitingList.APPLICATION_STATUS_SHEET(),
            method: 'GET',
            responseType: 'blob',
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'status.xlsx');
            document.body.appendChild(link);
            link.click();
        });
    }

    public toggleWaitingListTab(tabIndex: any) {
        if (this.activeType === this.tabs[tabIndex].requestOption) {
            return;
        }

        this.$store.commit(Mutations.CANCEL_REQUEST, { by: CANCEL_REQUEST_BY.BY_URL, url: Endpoints.Admin.WaitingList.WAITING_LISTS });

        if (!this.tabs[tabIndex].status) {
            this.$store.dispatch(Actions.RESET_PREVIEW_ALL_ACTIONS);
            this.$store.dispatch(Actions.TOGGLE_WAITING_LIST_TAB, this.tabs[tabIndex].requestOption);

            this.tabs.forEach((tab) => tab.status = false);
            this.tabs[tabIndex].status = true;
        }
    }

    public expirationEmailModal() {
        this.$store.commit(Mutations.SET_EXPIRATION_EMAIL_VISIBILITY, true);
    }

    public created() {
        this.$store.dispatch(Actions.FETCH_ALL_WAITING_LISTS);
    }
}
